import React from 'react';
import PropTypes from 'prop-types';
import './Tabs.scss';

/**
 * Tabs
 *
 * Generic, reusable tabs component.
 *
 * Renders only the tab list so that the parent page can decide
 * how to arrange headers, titles, and status indicators around it.
 *
 * The default classNames map to the existing Profile preview tabs
 * styles so it can be dropped into Profile without visual changes.
 */
export const Tabs = ({
  tabs = [],
  activeTabId,
  onTabChange,
  tabListClassName = 'tabs',
  tabBaseClassName = 'tabs__item',
}) => {
  const handleTabClick = (tabId, onClick) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
    if (typeof onClick === 'function') {
      onClick(tabId);
    }
  };

  return (
    <>
      {Array.isArray(tabs) && tabs.length > 0 && (
        <div className={tabListClassName}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type='button'
              className={`${tabBaseClassName} ${
                activeTabId === tab.id ? 'active' : ''
              }`}
              onClick={() => handleTabClick(tab.id, tab.onClick)}
              disabled={tab.disabled}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
  activeTabId: PropTypes.string,
  onTabChange: PropTypes.func,
  tabListClassName: PropTypes.string,
  tabBaseClassName: PropTypes.string,
};
